<template>
  <Scaffold :loading="loading">
    <template #toolbar>
      <ts-toolbar class="toolbar">
        <div class="top-row">
          <div class="title">Feedbacks</div>
          <ts-search-bar
              v-if="2 === 1"
            size="mini"
            placeholder="Search"
            class="search-bar"
            :value="filters.query"
            @input="handleQueryChange"
          ></ts-search-bar>
        </div>
      </ts-toolbar>
    </template>
    <div class="sorters">
      <TableHeader
        class="header"
        :column-definitions="columnDefinitions"
        :sorted-column-id="sorter.field"
        :sorted-by="sorter.by"
        @sort="handleSorterClick"
        @input="handleGlobalCheckboxChange"
      />
    </div>
    <div class="list" v-if="feedbacks.length > 0">
      <div
          v-for="feedback in feedbacks"
          :key="feedback.id"
          class="row-spec"
      >
        <div class="name">{{ feedback.name }}</div>
        <div>{{ feedback.cs }}</div>
        <div>{{ feedback.brand }}</div>
        <div>{{ formatDate(feedback.created_at) }}</div>
        <div>{{ feedback.productionType }}</div>
        <div>{{ feedback.projectType && feedback.projectType.name ? feedback.projectType.name : '' }}</div>
        <div>{{ feedback.rating }}/5</div>
        <div class="comment">{{ feedback.comment }}</div>
        <div class="break">{{ feedback.sale }}</div>
      </div>
    </div>
  </Scaffold>
</template>

<style lang="scss" scoped>
.mr-4 {
  margin-right: 1rem;
}
.toolbar {
  .top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 500;
      color: #6d7587;
    }

    .search-bar {
      width: 500px;
    }
  }

  .bottom-row {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }
}

.row-spec {
  border-top: 1px solid #9aa5b736;
  display: flex;
  padding: 10px 0 10px 0;
}

.row-spec div {
  width: 100px;
  font-size: 12px;
}

.row-spec div.name {
  width: 150px;
}

.row-spec div.comment {
  width: 200px;
  overflow-wrap: break-word;
}

.row-spec div.break {
  width: 200px;
  overflow-wrap: break-word;
}

.row-spec div.name {
  width: 150px;
  overflow-wrap: break-word;
}

.list {
  padding: 0px 20px;

  .row {
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    border: 2px solid rgba(255, 255, 255, 0.16);
    box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
    border-radius: 16px;

    display: flex;
    margin-bottom: 12px;

    .cell {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      padding: 12px;

      .centered {
        text-align: center;
      }

      .steps-statuses {
        font-family: Roboto;
        font-size: 8px;
        color: #9aa5b7;

        .step-status {
          display: flex;
          align-items: flex-end;
          margin: 2px 0;

          .badge {
            margin-right: 3px;
          }

          a {
            font-family: Roboto;
            font-size: 8px;
            color: #9aa5b7;
            text-decoration: none;
          }
        }
      }

      .project-name {
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        line-height: 20px;
        color: #000000;
      }

      .project-link {
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        text-decoration: none;
      }

      .project-brands {
        font-family: Roboto;
        font-size: 12px;
        color: #6d7587;
      }

      .project-quote-number {
        font-family: Roboto;
        font-size: 8px;
        color: #9aa5b7;
      }

      .due-date {
        font-family: Roboto;
        font-size: 12px;
        text-align: center;
        line-height: 50px;
        display: block;
        color: #6d7587;
      }

      .actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > * {
          margin-left: 12px;
        }
      }
    }
  }
}
.header {
  display: flex;

  .titles {
    flex-grow: 1;
  }

  .title {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .subtitle {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;

    margin-top: 12px;
  }

  .actions {
    flex-shrink: 0;
    margin-left: 50px;
    display: flex;

    > * {
      margin-left: 10px;
    }
  }
}

.list-actions {
  margin-bottom: 20px;
  display: flex;

  .select {
    flex-grow: 1;

    > * {
      margin-right: 23px;
    }
  }

  .actions {
    > * {
      margin-left: 8px;
    }
  }
}

.list-header {
  font-family: Roboto;
  font-size: 10px;
  color: #9aa5b7;

  display: flex;

  margin-bottom: 10px;

  .name-header {
    margin-left: 48px;
    width: 400px;
  }
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .users {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.sorters {
  margin: 30px 0px 10px 20px;
}

.sorters .name {
  font-size: 13px !important;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';

import Scaffold from '@/components/layouts/Scaffold.vue';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
import DatePickerDropdown from '@/components/inputs/DatePickerDropdown.vue';
import ProjectStatusSelect from '@/components/inputs/ProjectStatusSelect.vue';
import UserPicker from '@/components/inputs/UserPicker.vue';
import TableHeader from '@/components/TableHeader.vue';
import projectViewHelpers from '@/mixins/projectViewHelpers';

import Pen from '@/assets/pen.svg';
import Trash from '@/components/the-source-ui/icons/Trash.vue';
import Folder from './Folders/Folder.vue';
import CreateFolder from './Folders/CreateFolder.vue';
import PreventFolderArchiveDialog from './Folders/PreventFolderArchiveDialog.vue';
import MoveProjects from './Folders/MoveProjects.vue';
import {listFeedbacks} from "@/api/workflow";
import {format, parseISO} from "date-fns";

export default {
  mixins: [projectViewHelpers],
  components: {
    Scaffold,
    DatePickerDropdown,
    MultiSelectionDropdown,
    ProjectStatusSelect,
    UserPicker,
    Pen,
    Trash,
    Folder,
    CreateFolder,
    PreventFolderArchiveDialog,
    MoveProjects,
    TableHeader,
  },
  computed: {
    ...mapState('workflow', {
      loading: state => state.myProjects.loading,
      error: state => state.myProjects.error,
      projects: state => state.myProjects.items,
      filters: state => state.myProjects.filters,
      statuses: state => state.statuses.items,
      brands: state => state.myProjects.brands.items,
      users: state => state.myProjects.users.items
    })
  },
  methods: {
    ...mapActions('workflow', [
      'fetchBrands',
      'fetchUsers',
      'fetchMyProjects',
      'updateMyProjectsQuery',
      'updateMyProjectsFilter',
      'updateProjectStatus',
      'deleteProject',
      'exportProjects',
      'fetchProjectOptions',
      'updateProjectUsers'
    ]),
    handleCreateFolderClick() {
      window.EventBus.$emit('folders.create');
    },
    getBrand(brands) {
      let finalBrand = ''
      if(brands.length > 0) {
        brands.forEach(brand => {
          finalBrand + finalBrand + ' ' + brand.name
          }
        )
      }
    },
    getStepStatus(project, step) {
      const statusDetail = project.statusDetails[step];
      switch (statusDetail) {
        case 'pending':
          return 'error';
        case 'done':
          return 'success';
        default:
          console.error(`Status not found for project ${project.id}: ${step} (was ${statusDetail}`);
          return 'neutral';
      }
    },
    handleQueryChange(query) {
      this.updateMyProjectsQuery({ query });
    },
    handleFilterChange(field, value) {
      this.updateMyProjectsFilter({ field, value });
    },
    handleProjectStatusChange(project, value) {
      this.updateProjectStatus({ project, value });
    },
    handleDeleteClick(project) {
      if (!confirm('Delete this project?')) {
        return;
      }

      this.deleteProject({ project });
    },
    handleProjectUsersChange(project, value) {
      this.updateProjectUsers({ project, value });
    },
    handleProjectsExport() {
      this.exporting = true;
      this.exportProjects()
        .then(data => {
          var fileURL = window.URL.createObjectURL(new Blob([data.file]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', data.filename);
          document.body.appendChild(fileLink);

          fileLink.click();
          this.exporting = false;
        })
        .catch(error => (this.exporting = false));
    },
    handleCreateProjectClick() {
      this.$router.push({ name: 'create-project' });
    },
    handleEditClick(project) {
      this.$router.push({ name: 'project-details-general-info', params: { projectId: project.id } });
    },
    handleSorterClick(field) {
      this.checked = {};
    },
    formatDate(date) {
      return !date ? 'date not defined' : format(parseISO(date), 'PP');
    },
    handleGlobalCheckboxChange({ column, value }) {
      this.columnDefinitions = this.columnDefinitions.map(columnDefinition => {
        if (columnDefinition.id !== column) {
          return columnDefinition;
        }
        return {
          ...columnDefinition,
          checked: value
        };
      });
      this.checked = {};
      for (const analysis of this.analyses) {
        this.checked[analysis.uuid] = value;
      }
    },
  },
  async mounted() {
    const feedbacks = await listFeedbacks();
    this.feedbacks = feedbacks.reverse();
  },
  data() {
    return {
      sorter: {
        field: "name",
        by: "asc"
      },
      exporting: false,
      feedbacks: [
       ],
      columnDefinitions: [
        {
          id: 'name',
          name: 'Project name',
          width: 150
        },
        {
          id: 'cs',
          name: 'CS',
          width: 100
        },
        {
          id: 'brand',
          name: 'Brand',
          width: 100
        },
        {
          id: 'date',
          name: 'Date',
          width: 100
        },
        {
          id: 'productionType',
          name: 'Production type',
          width: 100
        },
        {
          id: 'projectType',
          name: 'Project type',
          width: 100,
        },
        {
          id: 'rating',
          name: 'Rating',
          width: 50
        },
        {
          id: 'comment',
          name: 'Comment',
          width: 300
        },
        {
          id: 'poc',
          name: 'POC',
          width: 100
        }
      ],
    };
  },
  watch: {
    error(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
